import createCommonModule from '@/common/store/modules/common';
import DomainGroup from '@/common/models/domainGroup.model';
import { PROJECT_ADMIN_USER_ROLE, PROJECT_NONE_USER_ROLE } from '@/common/constants/domains.constants';
import Vue from 'vue';
import { pick } from 'lodash-es';

const getDomainId = ({ rootState, rootGetters }) => rootState.routes.params.domainId || rootGetters.currentDomainId;

export default createCommonModule({
  namespaced: true,
  name: 'domainGroups',
  pagingSupport: false,
  resource: store => Promise.resolve(`/api/v2/domains/${getDomainId(store)}/groups`),
  Model: DomainGroup,
  state: {
    assignedUsers: {}
  },
  getters: {
    getAssignedUsers: state => groupId => state.assignedUsers[groupId]
  },
  mutations: {
    SET_ASSIGNED_USERS(state, { groupId, data = [] }) {
      Vue.set(state.assignedUsers, groupId, data.map(user => pick(user, ['id', 'name', 'role', 'email', 'description', 'identity_provider'])));
    },
    UNASSIGN_USER(state, { groupId, ids }) {
      state.assignedUsers[groupId] = state.assignedUsers[groupId].filter(user => !ids.includes(user.id));
    }
  },
  actions: {
    UPDATE_ASSIGNED_PROJECTS({ dispatch }, { domainGroupId, projectIdsToAssign = [], projectIdsToUnassign = [] }) {
      return dispatch('UPDATE', {
        id: domainGroupId,
        body: {
          assigned_projects: [
            ...projectIdsToAssign.map(id => ({ project_id: id, role: PROJECT_ADMIN_USER_ROLE })),
            ...projectIdsToUnassign.map(id => ({ project_id: id, role: PROJECT_NONE_USER_ROLE }))
          ]
        }
      });
    },
    FETCH_ASSIGNED_USERS({ commit }, { domainId, groupId }) {
      return this.$api.get(`/api/v2/domains/${domainId}/groups/${groupId}/users/`)
        .then(({ data }) => {
          commit('SET_ASSIGNED_USERS', {
            groupId,
            data: data.data
          });
        });
    },
    ASSIGN_USERS({ dispatch }, { domainId, groupId, ids }) {
      return this.$api.post(`/api/v2/domains/${domainId}/groups/${groupId}/users/`, {
        uuids: ids
      })
        .then(() => dispatch('FETCH_ASSIGNED_USERS', { domainId, groupId }));
    },
    UNASSIGN_USER({ commit }, { domainId, groupId, ids }) {
      return this.$api.delete(`/api/v2/domains/${domainId}/groups/${groupId}/users/`, {
        uuids: ids
      })
        .then(() => {
          commit('UNASSIGN_USER', { groupId, ids });
        });
    }
  }
});
